export default {
    min: 'min',
    sec: 'seg',
    suffix: '-pt',
    brand: 'Astrolink',
    gtm: 'GTM-KFFQDV4',
    toReadMore: 'Ler mais',
    toReadAll: 'Ler tudo',
    toSeeMore: 'Ver mais',
    toSeeLess: 'Ver menos',
    toSeeAll: 'Ver todos',
    toSeeMap: 'Ver mapa',
    knowMore: 'Saiba Mais',
    installment: '{installment}x de {value}',

    allRightsReserved: 'Todos os direitos reservados',

    offlineMessage: 'Você não está conectado à internet!',
    goBackMessage: 'Voltar para a página inicial',

    pageLoaderLoading: 'Consultando o céu...',
    pageLoaderTakingLong: 'Estamos alinhando suas informações com o céu. Se preferir, {link}.',
    pageLoaderGoBack: 'volte à área pessoal',

    stationeryHomeMaintenanceMessage: 'Nosso observatório está em manutenção\nTente novamente em alguns minutos',

    of: 'de',

    planets: {
        mars: 'Marte',
        venus: 'Vênus',
        mercury: 'Mercúrio',
        moon: 'Lua',
        sun: 'Sol',
        pluto: 'Plutão',
        jupiter: 'Júpiter',
        saturn: 'Saturno',
        uranus: 'Urano',
        neptune: 'Netuno',
        earth: 'Terra',
        north_node: 'Nodo norte',
        quiron: 'Quiron',
        lilith: 'Lilith',
        vertex: 'Vertex',
        point_of_fortune: 'P. da Fortuna',
        ascendant: 'Ascendente',
        midheaven: 'Meio do Céu'
    },

    signs: {
        aries: 'Áries',
        taurus: 'Touro',
        gemini: 'Gêmeos',
        cancer: 'Câncer',
        leo: 'Leão',
        virgo: 'Virgem',
        libra: 'Libra',
        scorpio: 'Escorpião',
        sagittarius: 'Sagitário',
        capricorn: 'Capricórnio',
        aquarius: 'Aquário',
        pisces: 'Peixes'
    },

    signsResumed: {
        aries: 'Ari',
        taurus: 'Tou',
        gemini: 'Gem',
        cancer: 'Can',
        leo: 'Lea',
        virgo: 'Vir',
        libra: 'Lib',
        scorpio: 'Esc',
        sagittarius: 'Sag',
        capricorn: 'Cap',
        aquarius: 'Aqu',
        pisces: 'Pei'
    },

    singsUnsex: {
        aries: 'Arian{gender}',
        taurus: 'Taurin{gender}',
        gemini: 'Geminian{gender}',
        cancer: 'Cancerian{gender}',
        leo: 'Leonin{gender}',
        virgo: 'Virginian{gender}',
        libra: 'Librian{gender}',
        scorpio: 'Escorpian{gender}',
        sagittarius: 'Sagitarian{gender}',
        capricorn: 'Capricornian{gender}',
        aquarius: 'Aquarian{gender}',
        pisces: 'Piscian{gender}'
    },

    elements: {
        water: 'Água',
        earth: 'Terra',
        air: 'Ar',
        fire: 'Fogo'
    },

    dignitys: {
        residence: 'domicílio',
        detraction: 'exílio',
        exaltation: 'exaltação',
        downfall: 'queda'
    },

    aspects: {
        conjunction: 'Conjunção',
        opposition: 'Oposição',
        trine: 'Trígono',
        square: 'Quadratura',
        sextile: 'Sextil'
    },

    moonPhases: {
        new: 'Nova',
        firstQuarter: 'Quarto crescente',
        full: 'Cheia',
        lastQuarter: 'Quarto minguante'
    },

    qualities: {
        cardinal: 'Cardinal',
        fixed: 'Fixo',
        changeable: 'Mutável'
    },

    moduleNotFound: 'Página não encontrada',
    errorContent: 'Não foi possível carregar o conteúdo',
    errorAction: {
        429: 'Você atingiu o limite de solicitações <br/>de amizade semanais.',
        400: 'Não foi possível realizar essa ação no momento. <strong> Tente mais tarde!</strong>'
    },

    confirm: 'Confirmar',
    cancel: 'Cancelar',
    close: 'Fechar',
    delete: 'Excluir',
    send: 'Enviar',

    updateAvailable: 'Novas atualizações disponíveis!',
    update: 'Atualizar',

    subscriptionButton: {
        title: 'Quero ser Premium',
        enable: 'Habilitar Recursos &nbsp;<strong>Premium</strong>',
        link: 'assinar'
    },

    date: {
        format: 'DD/MM/YYYY',
        fullDescriptiveDate: '{day} DE {monthName} DE {year} | {hour}H{minute}',
        weekly: {
            0: 'Domingo',
            1: 'Segunda-feira',
            2: 'Terça-feira',
            3: 'Quarta-feira',
            4: 'Quinta-feira',
            5: 'Sexta-feira',
            6: 'Sábado'
        },

        months: {
            0: 'Janeiro',
            1: 'Fevereiro',
            2: 'Março',
            3: 'Abril',
            4: 'Maio',
            5: 'Junho',
            6: 'Julho',
            7: 'Agosto',
            8: 'Setembro',
            9: 'Outubro',
            10: 'Novembro',
            11: 'Dezembro'
        }
    },

    routes: {
        otsError: 'ots/error',
        otsSuccess: 'ots/success',
        otsErrorCustomDestination: 'ots/error?destination=/{slug}',
        otsSuccessCustomDestination: 'ots/success?destination=/{slug}',
        contact: 'contato',
        calendar: 'calendar',
        subscription: 'assinar',
        birthChart: 'birth-chart',
        knowledge: 'knowledge',
        personalArea: 'personal-area',
        deleteAccount: 'delete-account',
        extraCharts: 'manage-charts',
        subscriptionError: 'assinar/error',
        aiAssistant: 'astrological-assistant',
        subscriptionBF: 'assinar/black-friday',
        subscriptionBFPlus: 'assinar/black-friday',
        subscriptionPromo: 'assinar/promo',
        subscriptionSuccess: 'assinar/success',
        tarot: 'tarot-consultations',
        compatibilities: 'compatibilities',
        horoscope: 'personal-horoscope',
        synastry: 'mapas/sinastria',
        lunarCycle: 'lunarcycle',
        features: {
            guide2025: 'guide2025',
            guide2026: 'guide2026',
            chakrasGuide: 'chakras-guide',
            careerMap: 'career-birth-chart'
        },
        completeBirthChart: '/mapa-astral-completo',
        resumedMap: 'resumed-map',
        generalUrl: ' ',
        loveMap: 'astral-love-guide',
        biorhythm: 'my-biorhythm',
        lunarNodes: 'lunarnodes',
        journal: 'diary',
        celebrities: 'famosos/listagem',
        dreams: 'https://chatgpt.com/g/g-68641cb19be88191a6cc6e1113fb15f7-sonya-significado-dos-sonhos-por-astrolink?target=_blank',
        profileBirthTime: 'my-profile?area=nascimento',

        visitors: 'visitantes',
        likes: 'favoritos?curtidas=true',
        friends: 'amigos',
        participants: 'participantes.php',
        astrologicalGuides: '/vault/',
        lessons: 'astrology-lessons',

        signs: {
            aries: 'aries',
            taurus: 'touro',
            gemini: 'gemeos',
            cancer: 'cancer',
            leo: 'leao',
            virgo: 'virgem',
            libra: 'libra',
            scorpio: 'escorpiao',
            sagittarius: 'sagitario',
            capricorn: 'capricornio',
            aquarius: 'aquario',
            pisces: 'peixes'
        },

        horoscopeSigns: {
            aries: 'horoscopo/aries',
            taurus: 'horoscopo/touro',
            gemini: 'horoscopo/gemeos',
            cancer: 'horoscopo/cancer',
            leo: 'horoscopo/leao',
            virgo: 'horoscopo/virgem',
            libra: 'horoscopo/libra',
            scorpio: 'horoscopo/escorpiao',
            sagittarius: 'horoscopo/sagitario',
            capricorn: 'horoscopo/capricornio',
            aquarius: 'horoscopo/aquario',
            pisces: 'horoscopo/peixes'
        },

        interpretation: {
            rising: {
                aries: '/interpretacao/ascendente-em-aries',
                taurus: '/interpretacao/ascendente-em-touro',
                gemini: '/interpretacao/ascendente-em-gemeos',
                cancer: '/interpretacao/ascendente-em-cancer',
                leo: '/interpretacao/ascendente-em-leao',
                virgo: '/interpretacao/ascendente-em-virgem',
                libra: '/interpretacao/ascendente-em-libra',
                scorpio: '/interpretacao/ascendente-em-escorpiao',
                sagittarius: '/interpretacao/ascendente-em-sagitario',
                capricorn: '/interpretacao/ascendente-em-capricornio',
                aquarius: '/interpretacao/ascendente-em-aquario',
                pisces: '/interpretacao/ascendente-em-peixes'
            }
        },

        planets: {
            sun: 'sol',
            moon: 'lua',
            mercury: 'mercurio',
            venus: 'venus',
            mars: 'marte',
            jupiter: 'jupiter',
            saturn: 'saturno',
            uranus: 'urano',
            neptune: 'netuno',
            pluto: 'plutao',
            chiron: 'quiron',
            ascendantArticle: 'artigo/ascendente',
            midheaven: 'artigo/meio-do-ceu'
        },

        houses: {
            introduction: 'artigo/as-casas-astrologicas',
            house1: 'casa1',
            house2: 'casa2',
            house3: 'casa3',
            house4: 'casa4',
            house5: 'casa5',
            house6: 'casa6',
            house7: 'casa7',
            house8: 'casa8',
            house9: 'casa9',
            house10: 'casa10',
            house11: 'casa11',
            house12: 'casa12'
        },

        tarotSubmenu: {
            consult: '/consultas-tarot',
            about: '/tarot',
            majorArcana: '/tarot/arcanos-maiores',
            minorArcana: '/tarot/arcanos-menores',
            clubs: '/tarot/naipe/paus',
            diamonds: '/tarot/naipe/ouros',
            spades: '/tarot/naipe/espadas',
            hearts: '/tarot/naipe/copas'
        },

        blog: {
            basicAstrology: 'posts/astrologia',
            dailyLife: 'posts/transitos-e-previsoes',
            numerology: 'posts/numerologia',
            tarotGypsy: 'posts/tarot-e-baralho-cigano',
            relationship: 'posts/relacionamentos-e-vida-emocional'
        }
    },

    feedback: {
        button: 'Enviar',
        title: 'Sua opinião é opcional, mas muito importante! O que achou desse conteúdo?',
        subtitle: 'O que achou desse conteúdo?',
        radioNotCheckedWarning: 'Antes de enviar seu feedback, você deve selecionar uma opção!',

        feedbackRedesign: {
            default: {
                title: 'DEIXE SUA OPINIÃO',
                subtitle: 'O que você achou desta experiência?',
                likeButton: 'Gostei',
                dislikeButton: 'Não Gostei',
                placeholder: 'Opcional: Gostaria de deixar um comentário?',
                submitButton: 'Enviar',
                submittedMessage: {
                    title: 'Obrigado por enviar sua opinião!',
                    positive: {
                        web: {
                            text: 'Que bom que você gostou! Aproveite para explorar outras ferramentas do Astrolink no menu.',
                            resendText: ' Você também pode ',
                            resendLink: 'reenviar sua opinião.'
                        },
                        app: {
                            text: 'Que tal nos ',
                            playStoreLink: 'avaliar na Play Store?',
                            appleStoreLink: 'avaliar na Apple Store?',
                            resendText: ' Você também ',
                            resendLink: 'pode reenviar sua opinião.'
                        }
                    },
                    negative: {
                        text: 'Se precisar de ajuda, entre contato com o nosso ',
                        supportLink: 'Suporte',
                        continuationText: '. Você também pode ',
                        resendLink: 'reenviar sua opinião.'
                    }
                },
                qualitativeResearch: {
                    title: 'Você é um cliente especial!',
                    description:
                        'Responda uma pesquisa rápida sobre a nova tela inicial e nos ajude a deixar o Astrolink perfeito para você!',
                    buttonText: 'Responder Pesquisa'
                }
            },

            lifeAreas: {
                placeholder: 'Digite sua sugestão...',
                subtitle: 'Qual funcionalidade você gostaria de ver no Astrolink?'
            },

            calendar: {
                subtitle: 'O que você achou do Calendário?'
            },

            'lunar-cycle': {
                subtitle: 'O que você achou do Ciclo Lunar?'
            },

            'neo-tarot': {
                subtitle: 'O que você achou da Consulta ao Tarot?'
            },

            'orbia-tarot': {
                subtitle: 'O que você achou do Tarot Inteligente?'
            },

            'new-home-app': {
                subtitle: 'O que você achou da nossa tela inicial?'
            },

            orbia: {
                subtitle: 'Sua opinião é opcional, mas muito importante! O que achou desse conteúdo?'
            },

            'summarized-horoscope': {
                subtitle: 'Sua opinião é opcional, mas muito importante! O que achou dessa ferramenta?'
            },

            mapa: {
                subtitle: 'O que você achou do seu Mapa Astral?'
            },

            'mapa-famosos': {
                subtitle: 'O que você achou do mapa desta personalidade?'
            },

            diario: {
                subtitle: 'O que você achou do Diário Lunar?'
            },

            biorhythm: {
                subtitle: 'O que você achou do seu Biorritmo?'
            },

            nodos: {
                subtitle: 'O que você achou dos Nodos Lunares?'
            },

            'chakras-guide-conclusao': {
                subtitle: 'O que você achou do Guia de Chakras?'
            }
        }
    },

    appStore: {
        apple: {
            name: 'Apple Store',
            url: 'https://apps.apple.com/br/app/astrolink-mapa-astral/id1598327566'
        },
        play: {
            name: 'Google Play',
            url: 'https://play.google.com/store/apps/details?id=com.astrolink.webapp'
        }
    },

    appRedirect: {
        title: 'O Astrolink é ainda melhor no aplicativo!',
        cta: 'Baixar o app',
        logo: 'assets/images/bg-banner-explorar.webp'
    },

    genderSuffix: {
        M: 'o',
        F: 'a'
    },

    day: 'd',

    typingLoader: {
        cosmicPhrases: {
            connectingPlanets: '🪐 Estabelecendo conexão com os planetas...',
            mappingEnergies: '🗺️ Mapeando energias cósmicas..',
            translatingSky: '☀️ Traduzindo o céu para você...',
            callingMercury: '📡 Colocando Mercúrio na linha...',
            convincingSaturn: '⏳ Convencendo Saturno a colaborar...',
            translatingNeptune: '🌊 Traduzindo Netuno sem dicionário...',
            cleaningDust: '✨ Limpando a poeira cósmica do sistema solar...',
            checkingMoon: '🌝 Conferindo se a Lua está de bom humor...',
            openingDoors: '🚪 Abrindo as portas celestes…',
            listeningStars: '🌟 Ouvindo os sussurros das estrelas...',
            drawingOrbit: '💫 Desenhando a sua órbita...'
        }
    }
};
